<script setup lang="ts">
import UiLoader from "@/components/Ui/UiLoader.vue";
import UiModal from "@/components/Ui/Modal/UiModal.vue";
import {ref} from "vue";
import {useQuizStore} from "@/stores/quizStore.ts";

const dpfModalIsOpen = ref(false)
const pcpModalIsOpen = ref(false)
const dpfIframeIsLoaded = ref(false)
const pcpIframeIsLoaded = ref(false)


const {vehicles} = useQuizStore()
</script>

<template>
  <div class="text-center mb-6 flex flex-col">
    <a v-if="!!vehicles.length" href="#" class="text-blue-500 text-sm" @click.prevent="() => {
      dpfIframeIsLoaded = false
      dpfModalIsOpen = true
    }">DPF Summary &
      Example Client Contract</a>

    <a href="#" class="text-blue-500 text-sm" @click.prevent="() => {
      pcpIframeIsLoaded = false
      pcpModalIsOpen = true
    }">PCP Summary &
      Example Client Contract</a>

  </div>
  <UiModal v-if="!!vehicles.length" title="DPF Summary & Example Client Contract" class="bg-white"
           :is-open="dpfModalIsOpen"
           @close="dpfModalIsOpen = false">
    <div v-if="!dpfIframeIsLoaded"
         class="w-full h-full absolute left-0 top-0 flex items-center justify-center bg-white">
      <UiLoader/>
    </div>
    <iframe src="https://claims.johnsonlawgroup.co.uk/contracts/preview.php?contract=31"
            frameborder="0" class="w-full h-[calc(100vh-100px)]" height="100%" width="100%"
            @load="dpfIframeIsLoaded = true"/>
  </UiModal>

  <UiModal title="PCP Summary & Example Client Contract" class="bg-white"
           :is-open="pcpModalIsOpen"
           @close="pcpModalIsOpen = false">
    <div v-if="!pcpIframeIsLoaded"
         class="w-full h-full absolute left-0 top-0 flex items-center justify-center bg-white">
      <UiLoader/>
    </div>
    <iframe src="https://claims.johnsonlawgroup.co.uk/contracts/preview.php?contract=30"
            frameborder="0" class="w-full h-[calc(100vh-100px)]" height="100%" width="100%"
            @load="pcpIframeIsLoaded = true"/>
  </UiModal>
</template>
